"use client";
import React, { createContext, useContext, useState, useEffect } from "react";
import { BettorProfileModel } from "common";
import { useUser } from "@clerk/nextjs";
import { useAuth } from "@clerk/clerk-react";
import { getBettorProfile } from "../bettor";
import { RoomProvider } from "./room";

interface BettorContextType {
  bettor: BettorProfileModel | null;
  setBettor: (bettor: BettorProfileModel | null) => void;
}

const BettorContext = createContext<BettorContextType>({
  bettor: null,
  setBettor: () => {},
});

export const useBettor = () => {
  const context = useContext(BettorContext);
  if (!context) {
    throw new Error("useBettor must be used within a BettorProvider");
  }
  return context;
};

export function BettorProvider({
  bettor: initialBettor,
  children,
}: {
  bettor: BettorProfileModel | null;
  children: React.ReactNode;
}) {
  const [bettor, setBettor] = useState<BettorProfileModel | null>(
    initialBettor
  );

  const { isSignedIn, user, isLoaded } = useUser();
  const { getToken } = useAuth();

  // useEffect(() => {
  //   console.log("user changed", isLoaded, isSignedIn);
  //   if (isLoaded && isSignedIn) {
  //     if (user.id) {
  //       (async () => {
  //         try {
  //           // await new Promise((resolve) => setTimeout(resolve, 5000));
  //           const token = await getToken();
  //           const bettorData: BettorProfileModel | null = await getBettorProfile(
  //             "clerk_id",
  //             user.id,
  //             token ? token : undefined
  //           );
  //           console.log("new bettor data", bettorData);
  //           setBettor(bettorData);
  //         } catch (error) {
  //           console.error("Error getting bettor data", error);
  //           setBettor(null);
  //         }
  //       })();
  //     } else {
  //       setBettor(null);
  //     }
  //   }
  // }, [user, isLoaded, isSignedIn]);

  return (
    <BettorContext.Provider value={{ bettor, setBettor }}>
      <RoomProvider type="bettor" id={bettor?.details?.id || undefined}>
        {children}
      </RoomProvider>
    </BettorContext.Provider>
  );
}
